<div class="card m-b-10" >
    <app-respondents-approval-search-page-header 
        (approveClicked)="approve()" ></app-respondents-approval-search-page-header>
    <div class="card-body">
        <div class="row p-t-20 p-b-20 add-by-category">
                <div class="col-12 d-flex justify-content-start">
                    <div class="d-flex">
                        <div>
                            <div class="caption">
                                    {{ 'lang.approval.searchByName'  | translate }}
                            </div>
                        </div>
                        <div class="m-l-10">
                            <span class="add-btn-white" (click)="navigateToSearchRespondent(respondentSelectionType.OtherRespondentMinAmount)"></span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div>
                            <div class="caption">
                                    {{ 'lang.approval.searchBU'  | translate }}
                            </div>
                        </div>
                        <div class="m-l-10">
                            <span class="add-btn-white" (click)="navigateToSearchRespondent(respondentSelectionType.BUSelection)"></span>
                        </div>
                    </div>
                </div>
        </div>
        <div class="ml-3 mr-3">
            <div class="row">
                <div class="col-12 block-search">
                        {{ 'lang.common.respondents'  | translate }}
                </div>
            </div>
            <div>
                <div *ngIf="getIsRespondentsExists(processRespondents$ | async)" >
                    <div *ngFor="let respondent of sortByRespondent(respondents)" class="row p-t-10 p-b-10 br-respondent">
                        <div class="col-4 pr-0">
                            <app-user-avatar [employeeId]="respondent.id"></app-user-avatar>
                            <div class="float-left">
                                <div class="font-weight-bold">
                                    {{ respondent.name }}
                                </div>
                                <div>
                                    {{ respondent.position }}
                                </div>
                            </div>
                        </div>
                        <div class="col-5 pr-0">
                            {{ respondent.businessUnitDisplayName }}
                        </div>
                        <div class="col-1 pr-0">
                            {{ respondent.grade }}
                        </div>
                        <div class="col-1 pr-0 text-right">
                            <i (click)="deleteRespondent(respondent)" class="ti-close"></i>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="m-b-10 m-t-10 btn-confirm-respondent"  (click)="approve()">
                            {{ 'lang.common.btn.approve'  | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
